module.exports = "<a href=\"javascript:void(0);\" (click)=\"openUploadDialog(1)\" class=\"btn btn-blue telecharger telecharger_assurance\">Télécharger</a>"